export default "__VITE_ASSET__BgmGZaPN__"